/** * 图片上传 公共组件 */
<template>
  <div class="uploadWrapper">
    <slot>
      <p class="words">* 文件名中不能存在分号、等号、和双引号。</p>
    </slot>
    <vuedraggable class="vue-draggable"
                  v-model="images"
                  tag="ul"
                  draggable=".draggable-item"
                  @start="onDragStart"
                  @end="onDragEnd"
                  :class="{ maxHidden: isMaxHidden }">
      <!-- :class="{ maxHidden: isMaxHidden }" -->
      <!-- 拖拽元素 -->
      <li v-for="(item, index) in imgList"
          :key="index"
          class="draggable-item"
          :style="{ width: width + 'px', height: height + 'px' }">
        <el-image :src="item"
                  :preview-src-list="imgList"></el-image>
        <!-- :src="item.url?item.url:item+ '?' + Date.parse(new Date())" -->
        <div class="shadow"
             @click="onRemoveHandler(index, item)"
             v-if="!disabled">
          <i class="el-icon-delete"></i>
        </div>
      </li>

      <!-- 上传按钮 -->
      <el-upload slot="footer"
                 ref="uploadRef"
                 class="uploadBox"
                 list-type="picture"
                 :style="{ width: width + 'px', height: height + 'px' }"
                 :data="paramData"
                 :name="name"
                 :multiple="multiple"
                 :limit="limit"
                 :accept="accept"
                 :file-list="imgList"
                 :auto-upload="true"
                 :show-file-list="false"
                 :headers="headers"
                 :action="wwwUrl + '/api' + action"
                 :before-upload="beforeUpload"
                 :on-exceed="onExceed"
                 :on-success="onSuccess"
                 :disabled="disabled">
        <i class="el-icon-plus uploadIcon">
          <!-- <span v-if="limit && limit !== 99"
                class="limitTxt">最多{{ limit }}张</span> -->
        </i>
      </el-upload>
    </vuedraggable>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
// import { validImgUpload } from "@/utils/validate";
// import lrz from "lrz"; // 前端图片压缩插件
// import tools from "@/utils/tools";
import * as publicApi from "@/http/publicApi.js";
import { mapState } from "vuex";

export default {
    props: {
        // 图片数据(图片url组成的数组) 通过v-model传递
        images: {
            type: Array,
            default() {
                return [];
            },
        },
        // 限制上传的图片数量
        limit: {
            type: Number,
            default: 100,
        },
        // 限制上传图片的文件大小(kb)
        size: {
            type: Number,
            default: 2,
        },
        // 是否使用图片压缩
        useCompress: {
            type: Boolean,
            default: true,
        },
        // 图片显示的宽度(px)
        width: {
            type: Number,
            default: 100,
        },
        // 图片显示的高度(px)
        height: {
            type: Number,
            default: 100,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        // 删除类型
        tb: {
            type: Number,
        },
        // 显示条件
        show: {
            type: Boolean,
            default: false,
        },
        // 图片主id
        pkid: {
            type: Number,
            default: null,
        },
        // 图片格式
        accept: {
            type: String,
            default: ".jpg,.png",
        },
        action: {
            type: String,
            default: "/v1/system/upload-img",
        },
        // 上传的文件字段名
        name: {
            type: String,
            default: "file",
        },
        // 上传时附带的额外参数
        paramData: {
            type: Object,
            default: function () {
                return {};
            },
        },
        clean: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            headers: {
                token: localStorage.getItem("token"),
            },
            imgList: [],
        };
    },

    computed: {
        // 控制达到最大限制时隐藏上传按钮
        isMaxHidden() {
            return this.imgList.length >= this.limit;
        },
        ...mapState({
            wwwUrl: (state) => state.index.wwwUrl,
        }),
    },
    watch: {
        images: {
            handler(newVal) {
                this.imgList = JSON.parse(JSON.stringify(newVal));
            },
            deep: true,
            immediate: false,
        },
        clean: {
            handler(newVal) {
                if (newVal == true) {
                    this.clear();
                }
            },
        },
    },
    methods: {
        clear() {
            this.$refs.uploadRef.clearFiles();
            this.imgList = [];
        },
        // 移除单张图片
        onRemoveHandler(index, item) {
            //console.log(item);
            this.$confirm("确定删除该图片?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    publicApi
                        .delFile(
                            {
                                image_url: item,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res.code == 200) {
                                this.imgList.splice(index, 1);
                                this.$emit("imagesChange", this.imgList);
                            }
                        })
                        .catch((err) => {
                            return false;
                        });
                })
                .catch(() => {});
        },
        onDragStart(e) {
            e.target.classList.add("hideShadow");
            this.$emit("imagesChange", this.imgList);
        },
        onDragEnd(e) {
            e.target.classList.remove("hideShadow");
            this.$emit("imagesChange", this.imgList);
        },
        onExceed() {
            this.$message.error(`文件不能超过${this.limit} 张`);
        },
        onSuccess(res, file, fileList) {
            if (this.imgList.length >= this.limit) {
                this.$message.error(`文件不能超过${this.limit} 张`);
            } else {
                if (res.data && res.code == 200) {
                    this.imgList.push(res.data);
                    this.$emit("imagesChange", this.imgList);
                } else {
                    this.$message.error("上传文件失败!");
                }
            }
        },
        beforeUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
            const extension = testmsg === "jpg" || testmsg === "png";
            const isLt2M = file.size / 1024 / 1024 < this.size; //这里做文件大小限制
            if (!extension) {
                this.$message.warning("上传文件只能是 jpg、png格式!");
                return false;
            }
            if (!isLt2M) {
                this.$message.warning(`上传文件大小不能超过 ${this.size} MB!`);
                return false;
            }
            return extension || (extension2 && isLt2M);
        },
    },
    components: { vuedraggable },
};
</script>

<style lang="scss" scoped>
.uploadWrapper {
    .words {
        text-align: left;
        color: red;
        font-size: 8px;
    }
    .text {
        font-size: 12px;
        color: $theme-color;
        text-align: left;
        width: 100%;
    }
    // 上传按钮
    .uploadIcon {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px dashed #c0ccda;
        border-radius: 6px; */
        background-color: #fbfdff;
        font-size: 20px;
        color: #999;

        .limitTxt {
            position: absolute;
            bottom: 10%;
            left: 0;
            width: 100%;
            font-size: 14px;
            text-align: center;
        }
    }

    // 拖拽
    .vue-draggable {
        display: flex;
        flex-wrap: wrap;
        .draggable-item {
            margin-right: 5px;
            margin-bottom: 5px;
            border: 1px solid #ddd;
            border-radius: 6px;
            position: relative;
            overflow: hidden;

            .el-image {
                width: 100%;
                height: 100%;
            }
            .shadow {
                position: absolute;
                top: 0;
                right: 0;
                background-color: rgba(0, 0, 0, 0.5);
                opacity: 0;
                transition: opacity 0.3s;
                color: #fff;
                font-size: 20px;
                line-height: 20px;
                padding: 2px;
                cursor: pointer;
            }
            &:hover {
                .shadow {
                    opacity: 1;
                }
            }
        }
        &.hideShadow {
            .shadow {
                display: none;
            }
        }
        &.single {
            overflow: hidden;
            position: relative;

            .draggable-item {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
            }
        }
        &.maxHidden {
            .uploadBox {
                display: none;
            }
        }
    }
    // el-image
    .el-image-viewer__wrapper {
        .el-image-viewer__mask {
            opacity: 0.8;
        }
        .el-icon-circle-close {
            color: #fff;
        }
    }
}
</style>
